import PhotoSwipeLightbox from "./photoswipe-lightbox.esm.min.js";

const MOBILE_MEDIA_QUERY = window.matchMedia("(max-width: 899px)");

function getChildrenSelector() {
  return MOBILE_MEDIA_QUERY.matches
    ? "a.hero__pic__zoom-link--mobile[data-image-banner-zoom]"
    : "a.hero__pic__zoom-link--desktop[data-image-banner-zoom]";
}

function destroyImageBannerZoom(section) {
  if (section._imageBannerLightbox) {
    section._imageBannerLightbox.destroy();
    delete section._imageBannerLightbox;
  }

  delete section.dataset.imageBannerZoomReady;
}

function initImageBannerZoom(section) {
  if (!section) return;

  destroyImageBannerZoom(section);

  const gallery = section.querySelector("[data-image-banner-zoom-gallery]");
  if (!gallery) return;

  const lightbox = new PhotoSwipeLightbox({
    gallery,
    children: getChildrenSelector(),
    pswpModule: () => import("./photoswipe.esm.min.js"),
    bgOpacity: 1,
  });

  lightbox.init();
  section.dataset.imageBannerZoomReady = "true";
  section._imageBannerLightbox = lightbox;
}

function initAllImageBannerZoom() {
  document
    .querySelectorAll("[data-image-banner-zoom-section]")
    .forEach(initImageBannerZoom);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAllImageBannerZoom);
} else {
  initAllImageBannerZoom();
}

MOBILE_MEDIA_QUERY.addEventListener("change", initAllImageBannerZoom);

document.addEventListener("shopify:section:load", (event) => {
  const section = event.target.querySelector("[data-image-banner-zoom-section]");
  if (section) initImageBannerZoom(section);
});

document.addEventListener("shopify:section:unload", (event) => {
  const section = event.target.querySelector("[data-image-banner-zoom-section]");
  if (section) destroyImageBannerZoom(section);
});
